export type Score = {
  id: number;
  gameId: string;
  trackId: string;
  playerName: string;
  score: number;
  createdAt: string;
};

export async function fetchScores(gameId: string, trackId?: string, limit = 10): Promise<Score[]> {
  const url = new URL(location.origin + '/api/scores');
  url.searchParams.set('gameId', gameId);
  if (trackId) url.searchParams.set('trackId', trackId);
  url.searchParams.set('limit', String(limit));

  const res = await fetch(url.toString(), {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('Failed to fetch scores');
  return res.json();
}

export async function submitScore(gameId: string, trackId: string, playerName: string, score: number): Promise<void> {
  const res = await fetch('/api/scores', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ gameId, trackId, playerName, score }),
  });
  if (!res.ok) throw new Error('Failed to submit score');
}
